import { useCookies } from "react-cookie";
import Accordion from "../ui/accordion";
import SectionHeadline from "../ui/SectionHeadline";
import Container from "../ui/Container";

interface CookieValues {
  trackingAccepted?: boolean;
}

const PrivacyText = () => {
  const [cookies, setCookie] = useCookies<"trackingAccepted", CookieValues>([
    "trackingAccepted",
  ]);

  return (
    <>
      <Container className="flex flex-col gap-2 text-left pt-12 md:w-[58%] lg:w-[58%] 2xl:w-[58%] min-h-[calc(100vh-32rem)]">
        <SectionHeadline className="flex flex-col items-center justify-center md:text-[70px]">
          Datenschutz
        </SectionHeadline>
        <Accordion
          trigger={
            <SectionHeadline className="text-[20px] px-0">
              1. Allgemeines
            </SectionHeadline>
          }
        >
          <div>
            <p className="mb-4">
              Die AUGUST STORCK KG (nachfolgend Storck genannt) nimmt den Schutz
              Ihrer persönlichen Daten sehr ernst und erhebt und nutzt Ihre
              Daten nur gemäß den Vorgaben der gesetzlichen
              Datenschutzbestimmungen.
            </p>
            <p className="mb-4">
              Storck ist Verantwortlicher für die Verarbeitung Ihrer Daten.
              Unsere Kontaktdaten sind:
            </p>
            <p className="mb-4">
              Adresse: AUGUST STORCK KG, Waldstraße 27, 13403 Berlin,
              Deutschland
              <br /> E-Mail-Adresse:{" "}
              <a
                className="text-muted-foreground hover:text-secondary-foreground active:text-cta-active focus:text-cta-click underline underline-offset-4 uppercase"
                href="mailto:info@de.storck.com"
              >
                info@de.storck.com
              </a>
              <br />
              Telefon: +49 30 41773-03
              <br />
            </p>
            <p className="mb-4">
              Wir haben einen Datenschutzbeauftragten bestellt, der für die
              Einhaltung dieser Datenschutzerklärung und die Beantwortung
              diesbezüglicher Fragen verantwortlich ist. Sollten Sie Fragen zu
              dieser Datenschutzerklärung haben, insbesondere Anfragen zur
              Ausübung Ihrer Rechte, kontaktieren Sie bitte unseren
              Datenschutzbeauftragten unter{" "}
              <a
                className="text-muted-foreground hover:text-secondary-foreground active:text-cta-active focus:text-cta-click underline underline-offset-4 uppercase"
                href="mailto:datenschutz@de.storck.com"
              >
                datenschutz@de.storck.com
              </a>
              .
            </p>
            <p className="mb-4">
              Soweit sich auf dieser Website Links zu anderen Seiten im Internet
              befinden, gilt diese Unterrichtung nicht für die Datenerhebung und
              -nutzung auf den verlinkten Seiten, da Storck auf deren Gestaltung
              und Inhalte keinerlei Einfluss hat.
            </p>
          </div>
        </Accordion>
        <Accordion
          trigger={
            <SectionHeadline className="text-[20px] px-0">
              2. Art, Umfang und Zwecke der Datenverarbeitung
            </SectionHeadline>
          }
        >
          <div>
            <p className="mb-4">
              <strong>2.1 Allgemeine Websitenutzung</strong>
            </p>
            <p className="mb-4">
              Wenn Sie unsere Website besuchen, werden temporär bestimmte
              Verbindungsdaten verarbeitet (insbesondere die IP-Adresse des
              anfragenden Rechners; die zuletzt besuchte URL; Zeit und Datum des
              Zugriffs; abgerufene Webseiten und Elemente wie Unterseiten oder
              Buttons; die übertragene Datenmenge; der Status, ob der Abruf
              erfolgreich war; die Beschreibung des Typs des verwendeten
              Webbrowsers und Gerätes). Wir verarbeiten diese Daten, soweit dies
              für Ihren Besuch auf der Website erforderlich ist. Rechtsgrundlage
              ist unser berechtigtes Interesse im Sinne von Artikel 6 Abs. 1 f
              EU-Datenschutzgrundverordnung (DSGVO) an der Bereitstellung
              unserer Website für die Zwecke der Außendarstellung und des
              Marketings. Außerdem speichern wir die Verbindungsdaten in den
              Logfiles unseres Webservers in unserem berechtigten Interesse an
              dem sicheren Betrieb des Webservers. Im Falle Ihrer Einwilligung
              verarbeiten wir die Verbindungsdaten in pseudonymisierter Form
              auch für die unter 2.2 genannten Zwecke.
            </p>
            <p className="mb-4">
              Bis auf die in dem vorstehenden Absatz genannten Daten ist die
              Nutzung unserer Website ohne Angabe personenbezogener Daten
              möglich (siehe auch Ziffer 7).
            </p>
            <p className="mb-4">
              <strong>
                2.2 Nutzungsanalyse zu Marketingzwecken sowie zur
                Website-Optimierung (Piwik PRO)
              </strong>
            </p>
            <p className="mb-4">
              Auf den Websites von Storck werden mit Piwik PRO Daten zu
              Marketing- und Optimierungszwecken verarbeitet, wenn Sie hierzu
              beim Aufruf der jeweiligen Website über unseren Cookie-Banner oder
              direkt hier in der Datenschutzerklärung über die untenstehende
              Checkbox Ihre Einwilligung erteilen. Über die Deaktivierung der
              Checkbox können Sie Ihre Einwilligung jederzeit widerrufen. Hierzu
              wird ein Cookie gesetzt, der ausschließlich ein weiteres Tracking
              durch Piwik PRO unterbindet.
            </p>
            <p className="mb-4">
              Zu den genannten Zwecken werden pseudonymisierte Nutzungsprofile
              mit den in Ziffer 2.1 genannten Daten sowie Daten über Ihre
              Aktivitäten auf unserer Website erstellt, insbesondere welche
              Unterseiten und Buttons Sie wann genutzt haben. Diese Profile
              enthalten keine Daten, mit denen Sie persönlich identifiziert
              werden können, wie z. B. Ihren Namen, und werden auch nicht mit
              solchen Daten kombiniert. Rechtsgrundlage für diese Analyse ist
              Ihre Einwilligung (Art. 6 Abs. 1 a DSGVO).
            </p>
            <p className="mb-4">
              Die Verarbeitung erfolgt im Auftrag von Storck auf Servern, die
              von der <strong>Piwik PRO GmbH</strong>, Kurfürstendamm 21, 10719
              Berlin, in Deutschland gehostet werden.
            </p>
            <ul
              id="1f1d1017-4e74-8077-b54b-c1a679fb952a"
              className="to-do-list"
            >
              <li>
                <div className="checkbox checkbox-off"></div>
                <span className="to-do-children-unchecked"></span>
                <div className="indented">
                  <p className="mb-4">
                    <input
                      type="checkbox"
                      id="trackingAccepted"
                      className="mr-2"
                      checked={cookies.trackingAccepted === true}
                      onChange={(e) => {
                        setCookie("trackingAccepted", e.target.checked, {
                          expires: new Date(
                            Date.now() + 180 * 24 * 60 * 60 * 1000,
                          ),
                        });
                      }}
                    />
                    <label htmlFor="trackingAccepted">
                      Tracking ist{" "}
                      {cookies.trackingAccepted === true
                        ? "aktiviert"
                        : "deaktiviert"}
                      .
                    </label>
                  </p>
                </div>
              </li>
            </ul>
            <p className="mb-4">
              <strong>2.3 Cookies</strong>
            </p>
            <p className="mb-4">
              Wir verwenden auf unserer Website Cookies. Dabei verwenden wir
              ohne Ihre Einwilligung lediglich solche Cookies, die unbedingt
              erforderlich sind, um Ihnen diese Website und die Ihrerseits
              gewünschten Funktionen technisch einwandfrei bereitstellen zu
              können und Ihnen eine komfortable Darstellung und Bedienung der
              Website zu ermöglichen.
            </p>
            <p className="mb-4">
              Cookies, die darüber hinaus der Durchführung von Analysen des
              Nutzerverhaltens zu Marketing- und Optimierungszwecken dienen,
              verwenden wir ausschließlich, wenn Sie uns hierzu ausdrücklich
              Ihre Einwilligung erteilt haben (§ 25 Abs. 1 TDDDG). Sofern Sie
              Ihre Einwilligung hierzu erteilt haben, können Sie diese jederzeit
              widerrufen. Um Ihre Einwilligung in diese Nutzungsanalyse und die
              damit verbundenen Cookies zu widerrufen, folgen Sie bitte der
              Anleitung in Ziffer 2.2.
            </p>
            <p className="mb-4">
              Folgende Cookies werden bei Ihrem Besuch unserer Website gesetzt
              (die als optional gekennzeichneten Cookies werden nur gesetzt,
              sofern Sie einwilligen):
            </p>
            <Accordion
              initialOpen
              trigger={
                <SectionHeadline className="text-[20px] px-0">
                  Cookies
                </SectionHeadline>
              }
            >
              <div>
                <table
                  id="1f1d1017-4e74-80b3-838b-d7886852b0aa"
                  className="simple-table mb-8"
                >
                  <tbody>
                    <tr className="border-b border-accent">
                      <td className="mb-4">
                        <strong>Cookie</strong>
                      </td>
                      <td className="mb-4">
                        <strong>Kategorie</strong>
                      </td>
                      <td className="mb-4">
                        <strong>Verarbeitung durch</strong>
                      </td>
                      <td className="mb-4">
                        <strong>Zweck</strong>
                      </td>
                      <td className="mb-4">
                        <strong>Speicherdauer</strong>
                      </td>
                    </tr>
                    <tr className="border-b border-accent">
                      <td className="mb-4">_pk_id</td>
                      <td className="mb-4">Tracking (optional)</td>
                      <td className="mb-4">Piwik (s. 2.2)</td>
                      <td className="mb-4">
                        Piwik Tracking – hinterlegt eine seitenspezifische ID
                        zur Zuordnung des Datensatzes
                      </td>
                      <td className="mb-4">12 Monate</td>
                    </tr>
                    <tr className="border-b border-accent">
                      <td className="mb-4">_pk_ses</td>
                      <td className="mb-4"></td>
                      <td className="mb-4">Piwik (s. 2.2)</td>
                      <td className="mb-4">
                        Piwik Tracking – hinterlegt eine ID für die aktuelle
                        Browser-Session des Nutzers zur Zuordnung des
                        Datensatzes
                      </td>
                      <td className="mb-4">30 Minuten</td>
                    </tr>
                    <tr className="border-b border-accent">
                      <td className="mb-4">stg_last_interaction</td>
                      <td className="mb-4"></td>
                      <td className="mb-4">Piwik (s. 2.2)</td>
                      <td className="mb-4">
                        Piwik Tracking – speichert den Moment der letzten
                        Interaktion des Nutzers
                      </td>
                      <td className="mb-4">12 Monate</td>
                    </tr>
                    <tr className="border-b border-accent">
                      <td className="mb-4">stg_returning_visitor</td>
                      <td className="mb-4"></td>
                      <td className="mb-4">Piwik (s. 2.2)</td>
                      <td className="mb-4">
                        Piwik Tracking – speichert, ob es sich um einen
                        wiederkehrenden Nutzer handelt
                      </td>
                      <td className="mb-4">12 Monate</td>
                    </tr>
                    <tr className="border-b border-accent">
                      <td className="mb-4">stg_externalReferrer</td>
                      <td className="mb-4"></td>
                      <td className="mb-4">Piwik (s. 2.2)</td>
                      <td className="mb-4">
                        Piwik Tracking - speichert die Referrer URL, über welche
                        sich der Nutzer auf die Website navigiert hat
                      </td>
                      <td className="mb-4">
                        Nur während der Browser-Sitzung (sog. Session Cookie)
                      </td>
                    </tr>
                    <tr className="border-b border-accent">
                      <td className="mb-4">stg_pk_campaign</td>
                      <td className="mb-4"></td>
                      <td className="mb-4">Piwik (s. 2.2)</td>
                      <td className="mb-4">
                        Piwik Tracking - Speichert einen Namen der Kampagne, die
                        einen Besucher auf diese Website verwiesen hat.
                      </td>
                      <td className="mb-4">
                        Nur während der Browser-Sitzung (sog. Session Cookie)
                      </td>
                    </tr>
                    <tr className="border-b border-accent">
                      <td className="mb-4">stg_fired_[...]</td>
                      <td className="mb-4"></td>
                      <td className="mb-4">Piwik (s. 2.2)</td>
                      <td className="mb-4">
                        Piwik Tracking - Bestimmt, ob die Kombination aus Tag
                        und Trigger während der Sitzung des aktuellen Besuchers
                        ausgelöst wurde.
                      </td>
                      <td className="mb-4">
                        Nur während der Browser-Sitzung (sog. Session Cookie)
                      </td>
                    </tr>
                    <tr className="border-b border-accent">
                      <td className="mb-4">piwikCampaign (only storck.com)</td>
                      <td className="mb-4"></td>
                      <td className="mb-4">Piwik (s. 2.2)</td>
                      <td className="mb-4">
                        Piwik Tracking - Speichert die Kampagne, über die ein
                        Benutzer auf die Website gelangt ist.
                      </td>
                      <td className="mb-4">
                        Nur während der Browser-Sitzung (sog. Session Cookie)
                      </td>
                    </tr>
                    <tr className="border-b border-accent">
                      <td className="mb-4">SERVERID</td>
                      <td className="mb-4"></td>
                      <td className="mb-4">Storck</td>
                      <td className="mb-4">
                        Piwik Tracking - Stellt Load-Balancing-Funktionalität
                        bereit. Ermöglicht schnelleres Laden der Seite.
                      </td>
                      <td className="mb-4">
                        Nur während der Browser-Sitzung (sog. Session Cookie)
                      </td>
                    </tr>
                    <tr className="border-b border-accent">
                      <td className="mb-4">stg_traffic_source_priority</td>
                      <td className="mb-4"></td>
                      <td className="mb-4">Piwik (s. 2.2)</td>
                      <td className="mb-4">
                        Piwik Tracking – speichert, über welche Quelle
                        (Kampagne, Suchmaschine, direkte Eingabe) der Nutzer auf
                        die Website kam
                      </td>
                      <td className="mb-4">30 Minuten</td>
                    </tr>
                    <tr className="border-b border-accent">
                      <td className="mb-4">stg_optout</td>
                      <td className="mb-4"></td>
                      <td className="mb-4">Piwik (s. 2.2)</td>
                      <td className="mb-4">
                        Piwik Tracking – speichert, dass nicht getrackt wird
                      </td>
                      <td className="mb-4">12 Monate</td>
                    </tr>
                    <tr className="border-b border-accent">
                      <td className="mb-4">hideCookieNotification</td>
                      <td className="mb-4">
                        Cookie-Benachrichtigung (unbedingt erforderlich)
                      </td>
                      <td className="mb-4">Storck</td>
                      <td className="mb-4">
                        Cookie Notification – wird gesetzt, damit die Cookie
                        Notification nicht bei jedem Website-Besuch erneut
                        angezeigt wird
                      </td>
                      <td className="mb-4">24 Stunden</td>
                    </tr>
                    <tr className="border-b border-accent">
                      <td className="mb-4">hideLocationNotification</td>
                      <td className="mb-4">
                        Länderauswahl (unbedingt erforderlich)
                      </td>
                      <td className="mb-4">Storck</td>
                      <td className="mb-4">
                        Location Notification – wird gesetzt, damit der Country
                        Selector nicht bei jedem Besuch der storck.com erneut
                        angezeigt wird
                      </td>
                      <td className="mb-4">
                        Nur während der Browser-Sitzung (sog. Session Cookie).
                      </td>
                    </tr>
                    <tr className="border-b border-accent">
                      <td className="mb-4">trackingAccepted</td>
                      <td className="mb-4">
                        Use of cookies (unbedingt erforderlich)
                      </td>
                      <td className="mb-4">Storck</td>
                      <td className="mb-4">
                        Auswahl Cookie Banner - Speichert die Information, ob
                        der Nutzer das Setzen der Cookies für die Webanalyse
                        erlaubt oder ablehnt
                      </td>
                      <td className="mb-4">24 Stunden</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </Accordion>
            <p className="mb-4">
              <strong>
                2.4 Anfragen über das Kontaktformular oder auf sonstigem
                Kommunikationsweg
              </strong>
            </p>
            <p className="mb-4">
              Wenn Sie unser Kontaktformular nutzen, verarbeiten wir Ihre
              Nachricht, Ihren Vor- und Zunamen, Ihre E-Mail-Adresse, Ihr Land
              und – soweit Sie uns diese Angaben mitteilen – Ihre Telefonnummer,
              Ihre Anschrift und Ihr Unternehmen. Wir verarbeiten diese Daten
              zur Beantwortung Ihrer Anfrage. Eine Übermittlung Ihrer
              personenbezogenen Daten an Dritte findet dabei nur statt, wenn
              dies notwendig ist, um Ihre Anfrage zu beantworten (z. B. wenn Sie
              Informationen über eine andere Gesellschaft der Storck Gruppe
              anfragen). Die Rechtsgrundlage für die Verarbeitung ist Artikel 6
              Abs. 1 b DSGVO, sofern die Bearbeitung Ihres Anliegens einen mit
              Ihnen bestehenden Vertrag betrifft und zur Vertragserfüllung
              erforderlich ist oder wenn Ihre Anfrage sich auf die Durchführung
              vorvertraglicher Maßnahmen richtet. Im Übrigen ist die
              Rechtsgrundlage unser berechtigtes Interesse an der Bereitstellung
              eines Kontaktformulars und der Beantwortung allgemeiner Anliegen
              (Art. 6 Abs. 1 f DSGVO). Entsprechend diesem Absatz verarbeiten
              wir Ihre Daten auch, wenn Sie sich postalisch oder auf sonstigem
              Weg mit einer Anfrage an uns wenden.
            </p>
            <p className="mb-4">
              <strong>2.5 Teilnahme an Gewinnspielen und Aktionen</strong>
            </p>
            <p className="mb-4">
              Wenn Sie an einem von uns veranstalteten Gewinnspiel oder einer
              Aktion teilnehmen, verarbeiten wir die von Ihnen im Rahmen der
              Teilnahme angegebenen Daten (insbesondere Vor- und Zuname und
              Anschrift bzw. Kontaktdaten) zur Durchführung des mit Ihnen
              geschlossenen (Gewinnspiel-)Vertrags nach den jeweils geltenden
              Teilnahmebedingungen. Rechtsgrundlage ist die Verarbeitung zur
              Vertragserfüllung nach Artikel 6 Abs. 1 b DSGVO. Dieser Abschnitt
              gilt unabhängig davon, ob Sie durch Ausfüllen eines Web-Formulars,
              postalisch oder auf sonstigem Weg an dem Gewinnspiel oder einer
              Aktion teilnehmen.
            </p>
            <p className="mb-4">
              Für die Organisation und Durchführung eines Gewinnspiels oder
              einer Aktion (z. B. zur Erhebung der Teilnehmerdaten über ein
              Webformular, zur Ziehung von Gewinnern, zur Abwicklung der
              Gewinnausgabe oder Erfüllung der Aktion) setzen wir mitunter
              Dienstleister ein. Jeder Dienstleister wird von uns sorgfältig
              ausgewählt und ist nach den geltenden datenschutzrechtlichen
              Anforderungen als weisungsgebundener Auftragsverarbeiter für uns
              tätig und zur Einhaltung des Datenschutzes verpflichtet.
            </p>
            <p className="mb-4">
              <strong>2.6 Social Media Links</strong>
            </p>
            <p className="mb-4">
              Wir verzichten auf unseren Webseiten bewusst auf die Einbindung
              sogenannter Social Plugins, die bereits beim Laden der Webseite
              ohne Ihr weiteres Zutun Daten an die Betreiber der sozialen
              Netzwerke übertragen. Unsere Webseite enthält lediglich Links zu
              sozialen Netzwerken (z. B. Facebook und Twitter), d. h. beim
              Besuch unserer Webseite werden keine Daten an die Anbieter der
              sozialen Netzwerke weitergegeben. Wenn Sie einen Link zu einem der
              Betreiber der sozialen Netzwerke aufrufen, können aber – wie bei
              jedem Internetlink – ggf. Informationen (z. B. der verwendete
              Browser) an die Anbieter übermittelt werden. Haben Sie einen
              Account bei dem betreffenden sozialen Netzwerk und sind Sie bei
              Aufruf des Links eingeloggt, kann der Anbieter zudem den Besuch
              unserer Webseite Ihrem Social Media Account direkt zuordnen. Sie
              können dies verhindern, indem Sie sich vor Aufruf des Links
              ausloggen.
            </p>
            <p className="mb-4">
              Bitte beachten Sie, dass wir auf den Inhalt der verlinkten Seiten
              und die dort stattfindende Datenverarbeitung keinerlei Einfluss
              haben. Zweck und Umfang der Datenerhebung und die weitere
              Verarbeitung und Nutzung der Daten durch die sozialen Netzwerke
              sowie die Einstellungsmöglichkeiten zum Schutze Ihrer Privatsphäre
              entnehmen Sie bitte den Datenschutzhinweisen des jeweiligen
              Anbieters.
            </p>
            <p className="mb-4">
              <strong>2.7 Social Media Präsenzen</strong>
            </p>
            <p className="mb-4">
              Storck ist auf den unten stehenden Social Media Plattformen mit
              eigenen Unternehmensseiten präsent, um Informationen über Storck
              und seine Marken bereitzuhalten und in Kontakt mit Kunden zu
              treten.
            </p>
            <p className="mb-4">
              Bei Ihrem Besuch auf diesen Social Media Plattformen und dem
              Aufruf auch unserer Seiten auf diesen Plattformen werden durch den
              Betreiber der Plattform personenbezogene Daten verarbeitet. Die
              Verarbeitung erfolgt dabei regelmäßig ausschließlich zu den allein
              durch den Betreiber der jeweiligen Plattform festgelegten Zwecken
              und mit dessen technischen Mitteln. Wir haben weder Kenntnis von
              den Datenverarbeitungen der Plattformbetreiber noch können wir
              Einfluss hierauf nehmen.
            </p>
            <p className="mb-4">
              Teilweise stellen uns die Social Media Plattformen – nicht
              abdingbar – anonymisierte und zusammengefasste statistische Daten
              ihrer Nutzer und der Besucher unserer Seiten zur Verfügung. Wir
              haben weder Zugriff noch Einfluss auf die personenbezogenen Daten,
              die durch die jeweilige Plattform zur Erstellung dieser
              Statistiken verarbeitet werden.
            </p>
            <p className="mb-4">
              Wir verarbeiten personenbezogene Daten im Zusammenhang mit unseren
              Social Media Seiten nur dann selbst, wenn Sie mit uns in Kontakt
              treten, um uns beispielsweise Feedback zu unseren Produkten zu
              geben. Rechtsgrundlage ist in diesen Fällen unser berechtigtes
              Interesse im Sinne von Artikel 6 Abs. 1 f DSGVO an der Interaktion
              mit Interessenten an unserem Unternehmen und Produkten.
            </p>
            <p className="mb-4">
              Weitere Informationen zur Verarbeitung Ihrer personenbezogenen
              Daten durch die Betreiber der Social Media Plattformen sowie die
              Modalitäten für die Ausübung Ihrer Rechte finden Sie bei den
              jeweiligen Plattformen:
            </p>
            <p className="mb-4">
              <strong>Facebook und Instagram</strong>
            </p>
            <p className="mb-4">
              Wir sind auf Facebook und Instagram (Meta-Produkte) präsent, um
              uns mit Interessenten über unser Unternehmen und unsere Produkte
              auszutauschen. Für das Angebot der Storck Facebook- und
              Instagram-Seiten nutzen wir die technische Plattform und Dienste
              der Meta Platforms Ireland Ltd.
            </p>
            <p className="mb-4">
              Gemäß der Rechtsprechung des Europäischen Gerichtshofs besteht
              eine gemeinsame Verantwortlichkeit der Seiten-Betreiber und
              Facebook für die Verarbeitung personenbezogener Daten im
              Zusammenhang mit Seiten-Insights.
            </p>
            <p className="mb-4">
              Weitere Informationen finden Sie in unseren Datenschutzhinweisen
              auf unseren Seiten{" "}
              <a
                className="text-muted-foreground hover:text-secondary-foreground active:text-cta-active focus:text-cta-click underline underline-offset-4 uppercase"
                href="https://www.facebook.com/merci/"
              >
                www.facebook.com/merci
              </a>{" "}
              und{" "}
              <a
                className="text-muted-foreground hover:text-secondary-foreground active:text-cta-active focus:text-cta-click underline underline-offset-4 uppercase"
                href="https://www.instagram.com/merci_deutschland/"
              >
                www.instagram.com/merci_deutschland
              </a>
              .
            </p>
            <p className="mb-4">
              Die Facebook Datenrichtlinie finden Sie hier:{" "}
              <a
                className="text-muted-foreground hover:text-secondary-foreground active:text-cta-active focus:text-cta-click underline underline-offset-4 uppercase"
                href="https://www.facebook.com/policy"
              >
                www.facebook.com/policy
              </a>
              .
            </p>
            <p className="mb-4">
              Die Instagram-Datenschutzrichtlinie finden Sie hier:{" "}
              <a
                className="text-muted-foreground hover:text-secondary-foreground active:text-cta-active focus:text-cta-click underline underline-offset-4 uppercase"
                href="https://help.instagram.com/519522125107875"
              >
                help.instagram.com/519522125107875
              </a>
              .
            </p>
            <p className="mb-4">
              <strong>Pinterest</strong>
            </p>
            <p className="mb-4">
              Wir sind auf Pinterest präsent, um uns mit Interessenten über
              unser Unternehmen und unsere Produkte auszutauschen. Für das
              Angebot der Storck Pinterest-Seite nutzen wir die technische
              Plattform und Dienste der Pinterest Europe Ltd., Palmerston House,
              2nd Floor, Fenian Street, Dublin 2, Irland. Wenn Sie Pinterest
              besuchen, werden Daten über Ihre Nutzung von Pinterest in deren
              eigener und alleiniger Verantwortung verarbeitet.
            </p>
            <p className="mb-4">
              Weitere Informationen finden Sie in unseren Datenschutzhinweisen
              auf unserer Seite
            </p>
            <p className="mb-4">
              <a
                className="text-muted-foreground hover:text-secondary-foreground active:text-cta-active focus:text-cta-click underline underline-offset-4 uppercase"
                href="https://www.pinterest.de/mercischokolade/"
              >
                HTTPS://WWW.PINTEREST.DE/MERCISCHOKOLADE/
              </a>
            </p>
            <p className="mb-4">
              Die Pinterest Datenrichtlinie finden Sie hier:
            </p>
            <p className="mb-4">
              <a
                className="text-muted-foreground hover:text-secondary-foreground active:text-cta-active focus:text-cta-click underline underline-offset-4 uppercase"
                href="https://www.policy.pinterest.com/de/privacy-policy"
              >
                HTTPS://POLICY.PINTEREST.COM/DE/PRIVACY-POLICY
              </a>
            </p>
          </div>
        </Accordion>
        <Accordion
          trigger={
            <SectionHeadline className="text-[20px] px-0">
              3. Empfänger; Übermittlung in Drittländer
            </SectionHeadline>
          }
        >
          <div>
            <p className="mb-4">
              Unsere Website wird gehostet bei der denkwerk GmbH, Vogelsanger
              Straße 66, 50823 Köln, Deutschland, die als unser
              Auftragsverarbeiter vertraglich zur ordnungsgemäßen
              Datenverarbeitung verpflichtet ist.
            </p>
            <p className="mb-4">
              Im Rahmen von Gewinnspielen und Aktionen greifen wir
              gegebenenfalls auf die technische Unterstützung von weiteren
              Dienstleistern wie Internetagenturen zurück, die für uns
              entsprechende Webseitenbereiche erstellen und technisch betreiben.
              Diese Agenturen sind von uns ordnungsgemäß als Auftragsverarbeiter
              verpflichtet. Dabei können iframes oder vergleichbare
              Seitenelemente auf unserer Website eingesetzt oder es kann auf
              eigenständige Websites (Microsites) verlinkt werden, die direkt
              vom Server eines für uns tätigen Auftragsverarbeiters geladen
              werden. In diesem Fall erhält der jeweilige Auftragsverarbeiter
              die beim Laden dieser Elemente bzw. Websites von Ihrem Browser
              übermittelten Daten (Ziffer 2.1) sowie ggf. weitere Daten, die Sie
              zur Teilnahme am Gewinnspiel oder der Aktion über Web-Formulare
              oder auf sonstigem Weg bereitstellen.
            </p>
            <p className="mb-4">
              Soweit nicht in dieser Datenschutzerklärung angegeben, übermitteln
              wir Ihre Daten grundsätzlich nicht an Dritte. Eine Weitergabe
              erfolgt ausnahmsweise dann, wenn wir aufgrund gesetzlicher
              Bestimmungen und/oder behördlicher oder gerichtlicher Anordnungen
              zu einer Datenweitergabe verpflichtet sind.
            </p>
            <p className="mb-4">
              Eine Weitergabe Ihrer Daten an eine Stelle in einem Drittland (d.
              h. außerhalb des Europäischen Wirtschaftsraums) oder eine
              internationale Organisation findet grundsätzlich nicht statt.
              Soweit eine solche Weitergabe ausnahmsweise erforderlich ist,
              insbesondere weil eine von Ihnen gestellte Anfrage an eine unserer
              Gesellschaften in einem Drittland weiterzuleiten ist (Ziffer 2.4),
              stellen wir sicher, dass die Voraussetzungen von Kapitel V der
              DSGVO erfüllt sind und damit ein angemessenes Datenschutzniveau
              beim Empfänger gewährleistet ist. Hierfür verwenden wir bei Bedarf
              die EU-Standardvertragsklauseln für Datentransfers in Drittländer.
            </p>
          </div>
        </Accordion>
        <Accordion
          trigger={
            <SectionHeadline className="text-[20px] px-0">
              4. Dauer der Speicherung
            </SectionHeadline>
          }
        >
          <div>
            <p className="mb-4">
              Die in den Logfiles (Ziffer 2.1) gespeicherten personenbezogenen
              Informationen werden nach maximal sieben Tagen gelöscht bzw.
              anonymisiert.
            </p>
            <p className="mb-4">
              Im Übrigen löschen wir Ihre personenbezogenen Daten, sobald sie
              für die mit der Verarbeitung verfolgten Zwecke nicht mehr benötigt
              werden und soweit keine gesetzlichen Aufbewahrungspflichten
              entgegenstehen. Relevante Aufbewahrungsfristen nach dem deutschen
              Steuer- und Handelsrecht betragen sechs Jahre für alle
              Geschäftsbriefe (auch elektronische) und zehn Jahre für alle
              Informationen, die für Steuer und Buchhaltung relevant sind.
            </p>
          </div>
        </Accordion>
        <Accordion
          trigger={
            <SectionHeadline className="text-[20px] px-0">
              5. Datensicherheit
            </SectionHeadline>
          }
        >
          <div>
            <p className="mb-4">
              Storck hat die notwendigen technischen und organisatorischen
              Maßnahmen ergriffen, um die von Ihnen zur Verfügung gestellten
              personenbezogenen Daten vor Verlust, Zerstörung, Manipulation und
              unberechtigtem Zugriff zu schützen. Unsere Mitarbeiter und alle an
              der Datenverarbeitung beteiligten Personen sind zur Einhaltung
              datenschutzrelevanter Gesetze und dem vertraulichen Umgang mit
              personenbezogenen Daten verpflichtet. Unsere Mitarbeiter sind
              entsprechend geschult. Sowohl interne als auch externe Prüfungen
              sichern die Einhaltung aller datenschutzrelevanten Prozesse bei
              Storck.
            </p>
            <p className="mb-4">
              Zum Schutz der personenbezogenen Daten unserer Nutzer benutzen wir
              ein sicheres Online-Übertragungsverfahren, die sogenannte „Secure
              Socket Layer“ (SSL)-Übertragung. Sie erkennen dies daran, dass an
              den Adressbestandteil http:// ein „s“ angehängt („https://“) bzw.
              ein grünes, geschlossenes Schloss-Symbol angezeigt wird. Durch
              Anklicken des Symbols erhalten Sie Informationen über das
              verwendete SSL-Zertifikat. Die Darstellung des Symbols ist
              abhängig von der von Ihnen eingesetzten Browserversion. Die
              SSL-Verschlüsselung gewährleistet die verschlüsselte und
              vollständige Übertragung Ihrer Daten.
            </p>
          </div>
        </Accordion>
        <Accordion
          trigger={
            <SectionHeadline className="text-[20px] px-0">
              6. Ihre Rechte bezüglich personenbezogener Daten
            </SectionHeadline>
          }
        >
          <div>
            <p className="mb-4">
              Das Datenschutzrecht gewährt Ihnen eine Reihe von Rechten in Bezug
              auf Daten, die Ihre Person betreffen (sogenannte
              Betroffenenrechte).
            </p>
            <p className="mb-4">
              <strong>6.1 Recht auf Auskunft</strong>
            </p>
            <p className="mb-4">
              Sie haben das Recht, von uns eine Bestätigung darüber zu
              verlangen, ob wir Ihre persönlichen Daten verarbeiten. Ist dies
              der Fall, so haben Sie ein Recht auf Auskunft über diese Daten.
              Die Einzelheiten über Ihr Auskunftsrecht können Sie in Artikel 15
              DSGVO nachlesen.
            </p>
            <p className="mb-4">
              <strong>6.2 Recht auf Berichtigung und Vervollständigung</strong>
            </p>
            <p className="mb-4">
              Sie haben gemäß Artikel 16 DSGVO das Recht, von uns unverzüglich
              die Berichtigung der Sie betreffenden unrichtigen persönlichen
              Daten und die Vervollständigung unvollständiger persönlicher Daten
              zu verlangen.
            </p>
            <p className="mb-4">
              <strong>6.3 Recht auf Löschung</strong>
            </p>
            <p className="mb-4">
              Sie haben das Recht, von uns die unverzügliche Löschung Ihrer
              persönlichen Daten zu verlangen, sofern einer der in Artikel 17
              DSGVO genannten Gründe vorliegt. Ein solcher Grund für die
              unverzügliche Löschung kann zum Beispiel gegeben sein, wenn die
              persönlichen Daten für die Bearbeitung Ihres Anliegens nicht mehr
              notwendig sind oder Sie der Datenverarbeitung widersprochen haben.
            </p>
            <p className="mb-4">
              <strong>6.4 Recht auf Einschränkung der Verarbeitung</strong>
            </p>
            <p className="mb-4">
              Sie haben das Recht, von uns die Einschränkung der Verarbeitung
              Ihrer persönlichen Daten zu verlangen, wenn eine der in Artikel 18
              DSGVO genannten Voraussetzungen gegeben ist. So besteht zum
              Beispiel in dem Fall, dass Sie die Richtigkeit der Daten
              bestreiten, das Recht auf Einschränkung der Verarbeitung für die
              Dauer, die es uns ermöglicht, die Richtigkeit der Daten zu
              überprüfen.
            </p>
            <p className="mb-4">
              <strong>6.5 Recht auf Widerruf der Einwilligung</strong>
            </p>
            <p className="mb-4">
              Sie haben gemäß Artikel 7 Abs.3 DSGVO das Recht, eine erteilte
              Einwilligung in die Verarbeitung Ihrer persönlichen Daten
              jederzeit zu widerrufen. Der Widerruf gilt nur für zukünftige
              Datenverarbeitungen, das heißt, die bis zum erfolgten Widerruf
              stattgefundene Datenverarbeitung bleibt in diesem Fall rechtmäßig.
            </p>
            <p className="mb-4">
              <strong>6.6 Widerspruchsrecht</strong>
            </p>
            <p className="mb-4">
              <strong>
                Soweit sich die Datenverarbeitung durch uns auf ein berechtigtes
                Interesse gemäß Artikel 6 Abs. 1 f DSGVO stützt (siehe dazu oben
                die zu jeder Datenverarbeitung angegebene Rechtsgrundlage),
                haben Sie ein Widerspruchsrecht gemäß Artikel 21 Abs. 1 DSGVO.
                Das bedeutet, Sie können der Verarbeitung Ihrer persönlichen
                Daten durch uns jederzeit widersprechen, sofern Gründe
                vorliegen, die sich aus Ihrer besonderen Situation ergeben. Ihre
                persönlichen Daten werden nach Ihrem eingelegten Widerspruch
                nicht mehr von uns verarbeitet, es sei denn, es liegen
                nachweisbar zwingende schutzwürdige Gründe für die Verarbeitung
                vor, die Ihre Interessen, Rechte und Freiheiten überwiegen, oder
                die Verarbeitung dient der Geltendmachung, Ausübung oder
                Verteidigung von Rechtsansprüchen.
              </strong>
            </p>
            <p className="mb-4">
              <strong>
                Sofern wir personenbezogene Daten verarbeiten, um Direktwerbung
                zu betreiben, können Sie dem jederzeit nach Artikel 21 Abs. 2
                DSGVO widersprechen. In diesem Fall werden wir Ihre Daten nicht
                mehr zu diesem Zweck verarbeiten.
              </strong>
            </p>
            <p className="mb-4">
              <strong>6.7 Recht zur Beschwerde</strong>
            </p>
            <p className="mb-4">
              Sie haben ferner ein Recht zur Beschwerde bei der zuständigen
              Datenschutzaufsichtsbehörde. Soweit Sie Fragen oder Beschwerden
              zum Datenschutz bei Storck haben, empfehlen wir Ihnen jedoch, sich
              zunächst an unseren Datenschutzbeauftragten zu wenden (Ziffer 1).
            </p>
          </div>
        </Accordion>
        <Accordion
          trigger={
            <SectionHeadline className="text-[20px] px-0">
              7. Keine Pflicht zur Bereitstellung von Daten
            </SectionHeadline>
          }
        >
          <div>
            <p className="mb-4">
              Sie sind nicht gesetzlich oder vertraglich verpflichtet, Storck
              personenbezogene Daten für den Besuch der Webseite
              bereitzustellen. Für die Nutzung bestimmter Bereiche (insbesondere
              das Kontaktformular oder Gewinnspiele) kann die Angabe Ihrer Daten
              jedoch zur Bearbeitung Ihrer Anfrage bzw. der Durchführung des
              Gewinnspiels erforderlich sein.
            </p>
          </div>
        </Accordion>
        <Accordion
          trigger={
            <SectionHeadline className="text-[20px] px-0">
              8. Keine automatisierte Einzelentscheidung
            </SectionHeadline>
          }
        >
          <div>
            <p className="mb-4">
              Storck verwendet Ihre personenbezogenen Daten nicht für
              automatisierte Einzelentscheidungen.
            </p>
          </div>
        </Accordion>
        <Accordion
          trigger={
            <SectionHeadline className="text-[20px] px-0">
              9. Änderung der Datenschutzerklärung
            </SectionHeadline>
          }
        >
          <div>
            <p className="mb-4">
              Neue rechtliche Vorgaben, unternehmerische Entscheidungen oder die
              technische Entwicklung erfordern gegebenenfalls Änderungen in
              unserer Datenschutzerklärung. Die Datenschutzerklärung wird dann
              entsprechend angepasst. Die aktuelle Version finden Sie immer auf
              unserer Website.
            </p>
          </div>
        </Accordion>
      </Container>
    </>
  );
};

export default PrivacyText;
